module.exports = __webpack_public_path__ + "img/landos-slide__logo.png?bc8982d51f32fe8e1aaced90f8973d19";